

export const ReviewOne = {
id: 'reviews',
review: `“Lincoln was my teacher for more than one year. She helped me progress from intermediate English to advanced English. When I spoke to her, it felt like I was listening to a reporter for CNN – so her accent is very understandable, which is helpful. We worked on grammar, vocabulary, and most importantly – she helped me be more confident when I speak.” `,
author: '- Tereza, Czech Republic',
review2: `“When I met Lincoln, I just moved to America and I didn't know any English. She was very a patient and helpful teacher. She can speak Spanish, so that helped a lot. She taught me enough English so I could get a job and talk to people. I can now live in America and feel comfortable and happy.” `,
author2: '- Eloisa, USA',
review3: `“Frankly, Lincoln is the best teacher I have ever had. Always positive and well prepared for our lesson. What does your perfect English lesson look like? A serious hour with grammar book or a friendly chat and lots of new American slang words? She can do either. And proofreading, of course!” `,
author3: '- Alena, Czech Republic'
}


